import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect, {components} from 'react-select'
import styles from './ServicePriceSelect.scss';
import Price from "./Price";
import {__t} from "../lang/text-resource";

const ServicePriceSelect = ({
								name,
								options,
								onChange,
								selected,
								id,
								onMenuOpen,
								termCol,
								hideDiscountCol,
								monthText,
								dontReverseOptions,
							}) => {
	const customStyles = {
		indicatorSeparator: () => ({
			display: 'none'
		}),
		indicatorsContainer: () => ({
			'&>div': {
				padding: '6px 8px'
			}
		}),
		placeholder: () => ({
			fontStyle: 'italic',
			color: '#cccccb',
			marginLeft: '2px',
			marginRight: '2px',
			position: 'absolute',
			top: '50%',
			transform: 'translateY(-50%)',
			boxSizing: 'border-box',
			height: '100%'
		}),
		placeholderContainer: () => ({
			height: '40px'
		}),
		menu: (base, state) => ({
			backgroundColor: 'white',
			borderRadius: 0,
			boxShadow: '0px 2px 3px 0px rgba(34, 36, 38, 0.15)',
			marginTop: '-1px',
			border: '1px solid #cccccb',
			borderColor: (state.isFocused) ? '#FE4200' : '#cccccb',
			borderTop: 'none',
			position: 'absolute',
			width: '100%',
			// minWidth: '230px',
			zIndex: 1,
			color: '#333',
			'&:hover': {
				borderColor: '#FE4200'
			}
		}),
		valueContainer: (base) => ({
			...base,
			padding: '6px 7px',
			overflow: 'visible',
		}),
		singleValue: () => ({
			maxWidth: 'calc(100% - 8px)',
			// position: 'absolute',
			textOverflow: 'unset',
			whiteSpace: 'nowrap',
			// top: '50%',
			// transform: 'translateY(-50%)',
			boxSizing: 'border-box',
			backgroundColor: 'white'
		}),
		control: (base, state) => ({
			backgroundColor: 'white',
			alignItems: 'center',
			borderRadius: 0,
			borderStyle: 'solid',
			borderColor: (state.isFocused) ? '#FE4200' : '#cccccb',
			borderWidth: '1px',
			cursor: 'default',
			display: 'flex',
			// flexWrap: 'wrap',
			flexWrap: 'nowrap',
			justifyContent: 'space-between',
			// '-ms-flex-pack': 'justify',
			outline: '0',
			position: 'relative',
			transition: 'all 100ms',
			boxSizing: 'borderBox',
			'&:hover': {
				borderColor: '#FE4200'
			}
		}),
		option: (styles, {data, isDisabled, isFocused, isSelected}) => {
			return {
				...styles,
				padding: '8px',
				backgroundColor: isDisabled
				  ? null
				  : isSelected ? '#FDF8CE' : isFocused ? 'rgba(0, 0, 0, 0.03)' : null,
				color: isDisabled
				  ? '#ccc'
				  : isSelected
					? 'rgba(0, 0, 0, 0.95)'
					: '#333',
				cursor: isDisabled ? 'not-allowed' : 'default',
				'&:hover': {
					backgroundColor: 'rgba(0, 0, 0, 0.05)',
					color: 'rgba(0, 0, 0, 0.95)'
				}
			};
		},
	};

	const Option = (props) => {
		return (
		  <div data-test={`${name}-value-${props.data.id}`}>
			  <components.Option {...Object.assign({}, props, {isSelected: selected.id === props.data.id})} >
				  <table className={styles.optionContainer}>
					  <tbody>
					  <tr>
						  <td className={styles.term}>{props.data[termCol]}</td>
						  <td>
							  <Price
								value={props.data.priceNew}
								currency={props.data.currency}
								currencyClass={styles.currency}/>

							  {
								hideDiscountCol == false && props.data.discount > 0 &&
								<div className={styles.monthlyDiscountPrice}>
									<Price
									  value={props.data.monthlyPriceNew}
									  removeDoubleZeros={false}
									  currency={props.data.currency}/>/{monthText}
								</div>
							  }
						  </td>
						  {
							hideDiscountCol === false &&
							<td className={styles.discount}>
								{props.data.discount > 0 && `-${props.data.discount}%`}
							</td>
						  }
					  </tr>
					  </tbody>
				  </table>
			  </components.Option>
		  </div>
		);
	};
	let values = Array.isArray(options) ? options : Object.values(options);
	if (!dontReverseOptions) {
		values = values.reverse();
	}

	return (
	  <div>

		  <ReactSelect
			// menuIsOpen={true}
			id={id}
			name={name}
			onChange={onChange}
			options={values}
			styles={customStyles}
			isSearchable={false}
			components={{Option}}
			onMenuOpen={onMenuOpen}
			getOptionLabel={option => {
				return (
				  <div className={styles.optionLabel}>
					  <div className={styles.term}>
						  {option[termCol]}&nbsp;
					  </div>
					  <div className={styles.priceContainer}>
						  <Price
							value={option.priceNew}
							removeDoubleZeros={false}
							currency={option.currency}/>
					  </div>
				  </div>
				)
			}}
			value={
				values.filter((option) => {
					return option.id === selected.id;
				})
			}
		  />
	  </div>
	);

};

ServicePriceSelect.defaultProps = {
	termCol: 'term',
	hideDiscountCol: false,
	monthText: __t('мес'),
}

ServicePriceSelect.propTypes = {
	name: PropTypes.string.isRequired,
	selected: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
	options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
	onChange: PropTypes.func,
	id: PropTypes.string,
	onMenuOpen: PropTypes.func,
	termCol: PropTypes.string,
	hideDiscountCol: PropTypes.bool,
	monthText: PropTypes.string,
};

export default ServicePriceSelect;